import styles from './AppDownloadModal.module.scss';

import React from 'react';
import { AppDownloadArticle } from './AppDownloadArticle';
import { Modal, ModalProps } from './Modal';
import clsx from 'clsx';
import { CloseButton } from './CloseButton';

export const AppDownloadModal: React.FC<ModalProps & {children?: never}> = ({ className, onClose, ...props }) => (
  <Modal className={clsx(styles.modal, className)} onClose={onClose} {...props}>
    <CloseButton className={styles.closeButton} onClick={onClose} />
    <AppDownloadArticle />
  </Modal>
);
